import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authentication-success-popup',
  standalone: false,
  templateUrl: './authentication-success-popup.html',
  styleUrl: './authentication-success-popup.scss'
})
export class AuthenticationSuccessPopup {
  constructor(
    private dialogRef: MatDialogRef<AuthenticationSuccessPopup>,
    private router: Router
  ) {}

  goToDashboard() {
    this.dialogRef.close();
    this.router.navigate(['/dashboard']);
  }
}
